import qs from "qs";
import reporter from "./reporter";

/**
 * 注册埋点
 * https://doc.huanleguang.com/pages/viewpage.action?pageId=79889212
 * @param {string} regist_channel_type 注册方式
 */
export default function registTracker(regist_channel_type, user_id) {
  try {
    const trackData = {
      user_id,
      event_id: 39004,
      event_name: "regist",
      regist_channel_type,
    };

    const query = qs.parse(window.location.search, { ignoreQueryPrefix: true });

    const { _tracker_source } = query;

    if (_tracker_source) {
      trackData.source = `${trackData.page_nm}_${
        trackData.sub_page_nm || ""
      }_${_tracker_source}`;
    }

    reporter(trackData);
  } catch (error) {
    console.error(error);
  }
}
